import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-t-small', 'LetterTSmall', [["path",{"d":"M10 8h4"}],["path",{"d":"M12 8v8"}]]);